import store from './store/modules/index.js';

export default {
  store: store
}